<template>
  <div>
    <v-tabs
      color="transparent"
      v-model="tab"
      show-arrows
      class="billing-tab"
      v-if="isModeLabel"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-layout>
        <v-flex md3>
          <v-tab v-for="tabItem in tabs" :key="tabItem">
            <span class="tabItem">{{ tabItem }}</span>
          </v-tab>
        </v-flex>
      </v-layout>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(item, index) in 2" :key="'item' + index">
          <template v-if="index === 0">
            <PaginationController
              ref="tableController"
              v-model="warehouseTransactions"
              :getDataActionName="warehouseKey === 'system' ? 'getSystemTransactionsPagination' : `getWarehouseTransactionsPagination`"
              :actionPredicates="actionPredicates"
              :historyLimit="historyLimit"
              :haveStartDate="true"
              :select="transactionType"
              :outsideScrollToBottom="outsideScrollToBottom"
              :haveSearchBox="warehouseKey === 'system'"
              :searchBoxLabel="$t('searchForKeywords')"
              :hasTimeZoneSearchBox="true"
              :zoneType.sync="zoneType"
            >
              <template v-slot:dataTable>
                <v-data-table
                  :headers="headers"
                  :items="sortWarehouseTransactions"
                  class="elevation-1"
                  hide-actions>
                  <template v-slot:items="{item}">
                    <td class="text-xs-left">{{ +zoneType === 0 ? toTimestampString(item.createTime) : toTimestampStringUTC(item.createTime)}}</td>
                    <td class="text-xs-left text-capitalize">
                      {{ `${item.transactionType || (item.type === 'label' ? 'Fee' : item.type)}${item.subtype ? ` - ${item.subtype.toUpperCase()}${getBusinessId(item)}` : ''}` }}
                    </td>
                    <td class="text-xs-left">
                      <template v-if="item.transactionType === 'deposit' || item.type === 'deposit'">
                        <v-layout v-if="item.subType === 'AliPay'">{{item.subType}} - {{item.orderId}}</v-layout>
                        <v-layout v-else>{{item.cardType}} - ***** {{item.last4}}</v-layout>
                        <v-layout><div style="width: 55px">{{ $t('deposit') }}:</div><div>${{ item.originDepositAmount || item.amount}}<span v-if="item.subType === 'AliPay'">(${{ item.transactionFee || 0 }})</span></div></v-layout>
                        <v-layout v-if="item.bonuses && item.bonuses.details.length > 0"><div style="width: 55px">{{ $t('bonus') }}:</div><div>{{item.bonuses.details.map(promotion => `$${promotion.bonus}`).join(' + ')}}</div></v-layout>
                      </template>
                      <template v-else>
                        <div class="billing-note">{{ item.note }}</div>
                      </template>
                    </td>
                    <td v-if="item.amount || item.amount === 0" class="text-xs-left" :style="`color: ${item.amount > 0 ? 'green' : 'red'}`">
                      <template v-if="item.bonuses && item.bonuses.details.length > 0">
                        ${{ item.amount + item.bonuses.total }}
                      </template>
                      <template v-else>
                        ${{ item.amount }}
                      </template>
                    </td>
                    <td v-else-if="item.type === 'label'" class="text-xs-left" :style="`color: ${item.totalAmount > 0 ? 'red': 'green'}`">
                      ${{ item.type === 'label' ? -item.totalAmount : item.amount }}
                    </td>
                    <td v-else class="text-xs-left" :style="`color: ${item.amount <= 0 || item.totalAmount > 0 ? 'green' : 'red'}`">
                      ${{ item.amount || -item.totalAmount }}
                    </td>
                    <td v-if="!$store.getters.isModeLabel || isClientModelLabel" class="text-xs-left">${{ item.newBalance }}</td>
                    <td class="text-xs-left" v-if="!isTenant">
                      <v-layout v-if="item.operator">
                        {{ item.operator }}
                      </v-layout>
                    </td>
                    <td class="text-xs-center">
                      <v-layout v-if="item.subtype !== 'pod'">
                        <v-flex v-if="['fee', 'deposit', 'adjust'].includes(item.transactionType || item.type)"><v-btn color="primary" flat @click.stop="showTransactionDetail(item)">{{ $t('details') }}</v-btn></v-flex>
                        <v-flex v-else-if="warehouseKey === 'system' && ['adjust', 'label'].includes(item.type) && item.details"><v-btn color="primary" flat @click.stop="showTransactionDetail(item)">{{ $t('details') }}</v-btn></v-flex>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </template>
              <template v-slot:beforeSearchBox v-if="warehouseKey === 'system'">
                <v-flex md3>
                  <v-autocomplete
                    :items="transactionTypes"
                    item-value="value"
                    item-text="name"
                    v-model="transactionType"
                    :label="$t('transactionType')"></v-autocomplete>
                </v-flex>
              </template>
              <template v-slot:beforeMenu v-else>
                <v-flex md3>
                  <v-autocomplete
                    :items="transactionTypes"
                    item-value="value"
                    item-text="name"
                    v-model="transactionType"
                    :label="$t('transactionType')"></v-autocomplete>
                </v-flex>
                <v-flex md1></v-flex>
              </template>
            </PaginationController>
          </template>
          <template v-if="index === 1">
            <PaginationController
              ref="tableController"
              v-model="apiLabelTransactions"
              getDataActionName="getApiTransactions"
              :actionPredicates="apiActionPredicates"
              :historyLimit="apiHistoryLimit"
              :haveStartDate="true"
              :startDate="startDate"
              :select="apiTransactionType"
              :outsideScrollToBottom="outsideScrollToBottom"
              :haveSearchBox="false"
              :hasTimeZoneSearchBox="true"
              :zoneType.sync="zoneType"
              :isApi="true"
            >
              <template v-slot:dataTable>
                <v-data-table
                  :headers="headers"
                  :items="apiLabelTransactions"
                  class="elevation-1"
                  hide-actions>
                  <template v-slot:items="{item}">
                    <td class="text-xs-left">{{ +zoneType === 0 ? toTimestampString(item.createTime) : toTimestampStringUTC(item.createTime)}}</td>
                    <td class="text-xs-left text-capitalize">
                      {{ `${item.transactionType || (item.type === 'label' ? 'Fee' : item.type)}${item.subtype ? ` - ${item.subtype.toUpperCase()}${getBusinessId(item)}` : ''}` }}
                    </td>
                    <td class="text-xs-left">
                      <template v-if="item.transactionType === 'deposit' || item.type === 'deposit'">
                        <v-layout v-if="item.subType === 'AliPay'">{{item.subType}} - {{item.orderId}}</v-layout>
                        <v-layout v-else>{{item.cardType}} - ***** {{item.last4}}</v-layout>
                        <v-layout><div style="width: 55px">{{ $t('deposit') }}:</div><div>${{ item.originDepositAmount || item.amount}}<span v-if="item.subType === 'AliPay'">(${{ item.transactionFee || 0 }})</span></div></v-layout>
                        <v-layout v-if="item.bonuses && item.bonuses.details.length > 0"><div style="width: 55px">{{ $t('bonus') }}:</div><div>{{item.bonuses.details.map(promotion => `$${promotion.bonus}`).join(' + ')}}</div></v-layout>
                      </template>
                      <template v-else>
                        <div class="billing-note">{{ item.note }}</div>
                      </template>
                    </td>
                    <td v-if="item.amount || item.amount === 0" class="text-xs-left" :style="`color: ${item.amount > 0 ? 'green' : 'red'}`">
                      <template v-if="item.bonuses && item.bonuses.details.length > 0">
                        ${{ item.amount + item.bonuses.total }}
                      </template>
                      <template v-else>
                        ${{ item.amount }}
                      </template>
                    </td>
                    <td v-else-if="item.type === 'label'" class="text-xs-left" :style="`color: ${item.totalAmount > 0 ? 'red': 'green'}`">
                      ${{ item.type === 'label' ? -item.totalAmount : item.amount }}
                    </td>
                    <td v-else class="text-xs-left" :style="`color: ${item.amount <= 0 || item.totalAmount > 0 ? 'green' : 'red'}`">
                      ${{ item.amount || -item.totalAmount }}
                    </td>
                    <td v-if="!$store.getters.isModeLabel || isClientModelLabel" class="text-xs-left">${{ item.newBalance }}</td>
                    <td class="text-xs-left" v-if="!isTenant">
                      <v-layout v-if="item.operator">
                        {{ item.operator }}
                      </v-layout>
                    </td>
                    <td class="text-xs-center">
                      <v-layout v-if="item.subtype !== 'pod'">
                        <v-flex v-if="['fee', 'deposit', 'adjust'].includes(item.transactionType || item.type)">
                          <v-btn color="primary" flat @click.stop="showTransactionDetail(item)">
                            {{ $t('details') }}
                          </v-btn>
                        </v-flex>
                        <v-flex v-else-if="warehouseKey === 'system' && ['label-invoice', 'adjust', 'label'].includes(item.type) && item.details">
                          <v-btn color="primary" flat @click.stop="showTransactionDetail(item)">
                            {{ $t('details') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </template>
              <template v-slot:beforeMenu>
                <v-flex md3>
                  <v-autocomplete
                    :items="apiTransactionTypes"
                    item-value="value"
                    item-text="name"
                    v-model="apiTransactionType"
                    :label="$t('transactionType')"></v-autocomplete>
                </v-flex>
              </template>
            </PaginationController>
          </template>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <PaginationController
      v-else
      ref="tableController"
      v-model="warehouseTransactions"
      :getDataActionName="warehouseKey === 'system' ? 'getSystemTransactionsPagination' : `getWarehouseTransactionsPagination`"
      :actionPredicates="actionPredicates"
      :historyLimit="historyLimit"
      :haveStartDate="true"
      :select="transactionType"
      :outsideScrollToBottom="outsideScrollToBottom"
      :haveSearchBox="warehouseKey === 'system'"
      :searchBoxLabel="$t('searchForKeywords')"
      :hasTimeZoneSearchBox="true"
      :zoneType.sync="zoneType"
    >
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="sortWarehouseTransactions"
          class="elevation-1"
          hide-actions>
          <template v-slot:items="{item}">
            <td class="text-xs-left">{{ +zoneType === 0 ? toTimestampString(item.createTime) : toTimestampStringUTC(item.createTime)}}</td>
            <td class="text-xs-left text-capitalize">
              {{ `${item.transactionType || (item.type === 'label' ? 'Fee' : item.type)}${item.subtype ? ` - ${item.subtype.toUpperCase()}${getBusinessId(item)}` : ''}` }}
            </td>
            <td class="text-xs-left">
              <template v-if="item.transactionType === 'deposit' || item.type === 'deposit'">
                <v-layout v-if="item.subType === 'AliPay'">{{item.subType}} - {{item.orderId}}</v-layout>
                <v-layout v-else>{{item.cardType}} - ***** {{item.last4}}</v-layout>
                <v-layout><div style="width: 55px">{{ $t('deposit') }}:</div><div>${{ item.originDepositAmount || item.amount}}<span v-if="item.subType === 'AliPay'">(${{ item.transactionFee || 0 }})</span></div></v-layout>
                <v-layout v-if="item.bonuses && item.bonuses.details.length > 0"><div style="width: 55px">{{ $t('bonus') }}:</div><div>{{item.bonuses.details.map(promotion => `$${promotion.bonus}`).join(' + ')}}</div></v-layout>
              </template>
              <template v-else>
                <div class="billing-note">{{ item.note }}</div>
              </template>
            </td>
            <td v-if="item.amount || item.amount === 0" class="text-xs-left" :style="`color: ${item.amount > 0 ? 'green' : 'red'}`">
              <template v-if="item.bonuses && item.bonuses.details.length > 0">
                ${{ item.amount + item.bonuses.total }}
              </template>
              <template v-else>
                ${{ item.amount }}
              </template>
            </td>
            <td v-else-if="item.type === 'label'" class="text-xs-left" :style="`color: ${item.totalAmount > 0 ? 'red': 'green'}`">
              ${{ item.type === 'label' ? -item.totalAmount : item.amount }}
            </td>
            <td v-else class="text-xs-left" :style="`color: ${item.amount <= 0 || item.totalAmount > 0 ? 'green' : 'red'}`">
              ${{ item.amount || -item.totalAmount }}
            </td>
            <td v-if="!$store.getters.isModeLabel && !isClientModelLabel" class="text-xs-left">${{ item.newBalance }}</td>
            <td class="text-xs-left" v-if="!isTenant">
              <v-layout v-if="item.operator">
                {{ item.operator }}
              </v-layout>
            </td>
            <td class="text-xs-center">
              <v-layout v-if="item.subtype !== 'pod'">
                <v-flex v-if="['fee', 'deposit', 'adjust'].includes(item.transactionType || item.type)"><v-btn color="primary" flat @click.stop="showTransactionDetail(item)">{{ $t('details') }}</v-btn></v-flex>
                <v-flex v-else-if="warehouseKey === 'system' && ['adjust', 'label'].includes(item.type) && item.details"><v-btn color="primary" flat @click.stop="showTransactionDetail(item)">{{ $t('details') }}</v-btn></v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </template>
      <template v-slot:beforeSearchBox v-if="warehouseKey === 'system'">
        <v-flex md3>
          <v-autocomplete
            :items="transactionTypes"
            item-value="value"
            item-text="name"
            v-model="transactionType"
            :label="$t('transactionType')"></v-autocomplete>
        </v-flex>
      </template>
      <template v-slot:beforeMenu v-else>
        <v-flex md3>
          <v-autocomplete
            :items="transactionTypes"
            item-value="value"
            item-text="name"
            v-model="transactionType"
            :label="$t('transactionType')"></v-autocomplete>
        </v-flex>
        <v-flex md1></v-flex>
      </template>
    </PaginationController>
    <BillingTransactionDetail
      v-model="transactionDetailDialog"
      v-if="transactionDetailDialog"
      :transaction="transactionInEdit"
      :isTenant="!!isTenant"/>
    <TransactionDetailsPopup
      v-if="showTransactionPopup"
      v-model="showTransactionPopup"
      :transaction="transactionInEdit"/>
  </div>
</template>

<script>
import PaginationController from './PaginationController'
import BillingTransactionDetail from './BillingTransactionDetail'
import {timeTools} from '../utils/tools'
import TransactionDetailsPopup from './TransactionDetailsPopup'
import { mapGetters } from 'vuex'

export default {
  name: 'BillingTransactionTable',
  components: {
    PaginationController,
    BillingTransactionDetail,
    TransactionDetailsPopup
  },
  mixins: [timeTools],
  data () {
    const now = new Date()
    return {
      tabs: [this.$t('viteTransaction'), this.$t('apiTransaction')],
      tab: 0,
      monthPicker: false,
      month: new Date().toISOString().substr(0, 7),
      warehouseTransactions: [],
      historyLimit: 25,
      apiHistoryLimit: 25,
      transactionDetailDialog: false,
      transactionInEdit: {},
      transactionTypes: [
        {name: `--${this.$t('all')}--`, value: ''},
        {name: this.$t('fee'), value: 'fee'},
        {name: this.$t('adjust'), value: 'adjust'},
        {name: this.$t('deposit'), value: 'deposit'}
      ],
      apiTransactionTypes: [
        {name: `--${this.$t('all')}--`, value: ''},
        {name: this.$t('label'), value: 'label'},
        {name: this.$t('invoice'), value: 'label-invoice'},
        {name: this.$t('eei'), value: 'eei'},
        {name: this.$t('balance'), value: 'balance'}
      ],
      transactionType: '',
      apiTransactionType: '',
      showTransactionPopup: false,
      zoneType: 0,
      apiLabelTransactions: [],
      startDate: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters(['isModeLabel']),
    headers () {
      const { activeOrganization, isModeLabel } = this.$store.getters
      const headers = activeOrganization ? [
        { text: this.$t('date'), value: '', align: 'left', sortable: false },
        { text: this.$t('type'), value: '', align: 'left', sortable: false },
        { text: this.$t('note'), value: 'note', align: 'left', width: '60%', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('balance'), value: 'newBalance', align: 'left', sortable: false },
        { text: this.$t('actions'), value: 'methodForFilter', align: 'center', sortable: false, width: '8%' }
      ] : [
        { text: this.$t('date'), value: '', align: 'left', sortable: false },
        { text: this.$t('type'), value: '', align: 'left', sortable: false },
        { text: this.$t('note'), value: 'note', align: 'left', width: '60%', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('balance'), value: 'newBalance', align: 'left', sortable: false },
        { text: this.$t('operator'), value: '', align: 'left', sortable: false },
        { text: this.$t('actions'), value: 'methodForFilter', align: 'center', sortable: false, width: '8%' }
      ]
      if (isModeLabel || this.isClientModelLabel) {
        headers.splice(4, 1)
      }
      return headers
    },
    // cancel handle fee first
    sortWarehouseTransactions () {
      return this.warehouseTransactions.map(item => {
        if (item.keywords?.includes('cancel handle fee')) return { ...item, createTime: new Date(new Date(item.createTime).getTime() + 1) }
        return item
      }).sort((a, b) => new Date(b.createTime).getTime() - new Date(a.createTime).getTime())
    },
    isTenant () {
      return this.$store.getters.activeOrganization
    },
    apiActionPredicates () {
      return []
    },
    actionPredicates () {
      let predicates = []
      if (this.warehouseKey === 'system') {
        predicates.push({
          field: 'clientKey',
          compare: '==',
          value: this.tenantKey || this.$store.getters.activeOrganization || this.$store.getters.activeWarehouse
        })
      } else {
        this.tenantKey && predicates.push({
          field: 'tenantKey',
          compare: '==',
          value: this.tenantKey
        })
        this.warehouseKey && predicates.push({
          field: 'warehouseKey',
          compare: '==',
          value: this.warehouseKey
        })
      }

      return predicates
    }
  },
  methods: {
    getBusinessId (item) {
      if (!item.businessId) return ''
      const id = item.businessId.split('/').slice(-1)[0]
      return `\n[${id}]`
    },
    showTransactionDetail (item) {
      this.transactionInEdit = item
      if (['adjust'].includes(item.transactionType || item.type) && !item.details) {
        this.showTransactionPopup = true
      } else this.transactionDetailDialog = true
    },
    $$refresh () {
      if (this.isModeLabel || this.isClientModelLabel) {
        this.$nextTick(() => {
          this.$refs.tableController.forEach(item => item.$$initiateTable())
        })
      } else {
        this.$refs.tableController.$$initiateTable()
      }
    }
  },
  props: {
    tenantKey: String,
    warehouseKey: String,
    outsideScrollToBottom: Boolean,
    isClientModelLabel: Boolean
  }
}
</script>

<style scoped>
.billing-note {
  white-space: pre-wrap;
  overflow: auto;
  word-break: break-all;
}
.billing-tab >>> .v-tabs__container {
  height: 30px;
}
.billing-tab {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BillingTransactionTable.vue